"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledLoadingContentContent = exports.StyledSpinner = exports.StyledLoadingContentLoading = exports.StyledLoadingContent = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.StyledLoadingContent = styled_components_1.default.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
exports.StyledLoadingContentLoading = styled_components_1.default.span(function (_a) {
    var space = _a.theme.space, $loading = _a.$loading, leftAlign = _a.leftAlign;
    return "\n    position: absolute;\n    width: ".concat(space[12], ";\n    height: auto;\n    opacity: ").concat($loading ? 1 : 0, ";\n\n    ").concat(leftAlign
        ? "\n          left: 0;\n          top: 50%;\n          transform: translateY(-50%);\n        "
        : "\n          top: 50%;\n          left: 50%;\n          transform: translate(-50%, -50%);\n        ", "\n");
});
exports.StyledSpinner = styled_components_1.default.svg(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: block;\n  height: 100%;\n  width: auto;\n"], ["\n  display: block;\n  height: 100%;\n  width: auto;\n"])));
exports.StyledLoadingContentContent = styled_components_1.default.span(function (_a) {
    var $loading = _a.$loading;
    return "\n    position: relative;\n    display: inline-block;\n    opacity: ".concat($loading ? 0 : 1, ";\n");
});
var templateObject_1, templateObject_2;
